import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    boxShadow: theme.shadows[2],
    padding: theme.spacing(4),
    margin: theme.spacing(3),
  },
  head: {
    marginBottom: theme.spacing(3),
  },
  title: {
    fontWeight: 600,
  },
  section: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    background: theme.palette.grey[50],
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  rowsHeader: {
    display: 'flex',
    alignItems: 'baseline',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  sectionLabel: {
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    paddingLeft: theme.spacing(1),
  },
  counter: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.text.hint,
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
  },
  button: {
    minWidth: 180,
  },
  hint: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1.5),
    display: 'block',
  },
  error: {
    color: theme.palette.error.main,
  },
}));
